module.exports = __webpack_public_path__ + "static/media/marketplace-live-icon.3962add4.svg";